module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/hair_dryer-919ee7a71e7b86865c266c98c3df25aa.svg";